import React from "react";
import ReactDOM from "react-dom/client";
import { BaseApp } from "../BaseApp";
import App from "./App";

export class GersSamples extends BaseApp {
  public render = () => {
    const root = ReactDOM.createRoot(
      document.querySelector(this.htmlSelector) as HTMLElement
    );

    root.render(
      <React.StrictMode>
        <App configuration={this.configuration} />
      </React.StrictMode>
    );
  };
}
